import React from 'react';
import { Box, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { Breakpoint, SxProps, Theme } from '@mui/material/styles';

/** Nền trang chủ — dùng chung các trang user */
export const USER_PAGE_BG = `
  radial-gradient(ellipse 80% 50% at 0% -10%, ${alpha('#f48fb1', 0.28)} 0%, transparent 55%),
  radial-gradient(ellipse 60% 40% at 100% 0%, ${alpha('#ffc1e3', 0.35)} 0%, transparent 50%),
  linear-gradient(180deg, #fff8fa 0%, #ffffff 55%)
`;

export const userPageRootSx: SxProps<Theme> = {
  minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
  background: USER_PAGE_BG,
};

export const userPageContainerSx: SxProps<Theme> = {
  pt: { xs: 2, sm: 3 },
  pb: { xs: 4, sm: 5 },
  px: { xs: 1.5, sm: 3 },
};

export const userCardEnterSx = (index = 0): SxProps<Theme> => ({
  animation: 'dashCardIn 0.45s ease both',
  animationDelay: `${Math.min(index, 12) * 0.04}s`,
});

type UserPageLayoutProps = {
  children: React.ReactNode;
  maxWidth?: Breakpoint | false;
  /** Khối tiêu đề / tab trượt xuống giống trang chủ */
  enter?: boolean;
};

/** Nền + padding giống trang chủ — bọc các trang user. */
const UserPageLayout: React.FC<UserPageLayoutProps> = ({
  children,
  maxWidth = 'lg',
  enter = false,
}) => (
  <Box sx={userPageRootSx}>
    <Container
      maxWidth={maxWidth}
      className={enter ? 'user-page-layout user-page-enter' : 'user-page-layout'}
      sx={userPageContainerSx}
    >
      {children}
    </Container>
  </Box>
);

export default UserPageLayout;
